import { housesGateway } from "@/gateways/housesGateway";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { House } from "./types";

export function useGetHouses() {
  const query = useQuery({
    queryKey: ["houses"],
    queryFn: () => housesGateway.getHouses(),
    initialData: [],
  });

  return { ...query, getHousesStatus: query.status, houses: query.data };
}

export function useGetHouse(id: number) {
  const query = useQuery({
    queryKey: ["house", id],
    queryFn: () => housesGateway.getHouse(id),
  });

  return { ...query, getHouseStatus: query.status, house: query.data };
}

export function useUpdateHouse() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (house: House) => housesGateway.updateHouse(house),
    onSuccess: (house: House) => {
      queryClient.invalidateQueries({ queryKey: ["houses"] });
      queryClient.invalidateQueries({ queryKey: ["houseTags"] });
      queryClient.setQueryData(["house", house.id], house);
    },
  });

  return {
    ...mutation,
    updateHouseStatus: mutation.status,
    updateHouse: mutation.mutate,
  };
}

export function useUpdateHouseHidden() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, hidden }: { id: number; hidden: boolean }) =>
      housesGateway.patchHouseHidden(id, hidden),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["areaHouses"] });
    },
  });

  return {
    ...mutation,
    updateHouseHiddenStatus: mutation.status,
    updateHouseHidden: mutation.mutate,
  };
}

export function useGetAllTags() {
  const query = useQuery({
    queryKey: ["houseTags"],
    queryFn: () => housesGateway.getAllTags(),
    initialData: [],
  });
  return { ...query, getAllTagsStatus: query.status, tags: query.data };
}
